export default "__VITE_ASSET__C4XlqKD0__"